<template>
    <v-dialog v-model="show" hide-overlay fullscreen transition="dialog-bottom-transition">
        <div id="app" class="my-0 py-0">
            <v-app id="inspire">
                <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                    <v-card v-model="show" class="py-0">
                        <v-toolbar class="py-0 my-0" dark color="#d98880">
                            <v-toolbar-title class="my-0 py-0">Materiales Pendientes de Llegada / Compra / Reserva
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon dark @click="show = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar>
                    </v-card>
                    <v-card>
                        <v-card-text>
                            <v-data-table dense :headers="headers" :items="listadoP" :single-expand="true"
                                locale="es-ar" class="elevation-1" :items-per-page="200" hide-default-footer
                                :loading="loadtable" loading-text="Buscando... Espere por favor"
                                no-data-text="No hay datos">
                                <template v-slot:top>
                                    <v-toolbar flat dense>
                                        <v-toolbar-title center>
                                            <font color="green"> Pendientes de Llegada</font>
                                        </v-toolbar-title>
                                        <v-spacer></v-spacer>
                                    </v-toolbar>
                                </template>
                                <template v-slot:item.fechanecesidad="{ item }">
                                    <td class="font-class-name2">
                                        <v-btn :class="colorcelda(item.fechanecesidad)" class="font-class-name2">
                                            {{ item.fechanecesidad }}</v-btn>
                                    </td>
                                </template>
                                <template v-slot:item.fechavencimiento="{ item }">
                                    <td class="font-class-name2">
                                        <v-btn :class="colorcelda(item.fechavencimiento)" class="font-class-name2">
                                            {{ item.fechavencimiento }}</v-btn>
                                    </td>
                                </template>
                            </v-data-table>
                            <v-data-table dense :headers="headersC" :items="listadoC" :single-expand="true"
                                locale="es-ar" class="elevation-1" :items-per-page="200" hide-default-footer
                                :loading="loadtableC" loading-text="Buscando... Espere por favor"
                                no-data-text="No hay datos">
                                <template v-slot:top>
                                    <v-toolbar flat dense>
                                        <v-toolbar-title center>
                                            <font color="green"> Pendientes de Compra</font>
                                        </v-toolbar-title>
                                        <v-spacer></v-spacer>
                                    </v-toolbar>
                                </template>
                                <template v-slot:item.fechanecesidad="{ item }">
                                    <td class="font-class-name2">
                                        <v-btn :class="colorcelda(item.fechanecesidad)" class="font-class-name2">
                                            {{ item.fechanecesidad }}</v-btn>
                                    </td>
                                </template>
                            </v-data-table>
                            <v-data-table dense :headers="headersF" :items="listadoF" :single-expand="true"
                                locale="es-ar" class="elevation-1" :items-per-page="200" hide-default-footer
                                :loading="loadtableF" loading-text="Buscando... Espere por favor"
                                no-data-text="No hay datos">
                                <template v-slot:top>
                                    <v-toolbar flat dense>
                                        <v-toolbar-title center>
                                            <font color="green">Solicitados a Fabricación Faltantes</font>
                                        </v-toolbar-title>
                                        <v-spacer></v-spacer>
                                    </v-toolbar>
                                </template>
                            </v-data-table>
                            <v-data-table dense :headers="headersR" :items="listadoR" :single-expand="true"
                                locale="es-ar" class="elevation-1" :items-per-page="200" hide-default-footer
                                :loading="loadtableR" loading-text="Buscando... Espere por favor"
                                no-data-text="No hay datos">
                                <template v-slot:top>
                                    <v-toolbar flat dense>
                                        <v-toolbar-title center>
                                            <font color="green">Reservados sin Entrega</font>
                                        </v-toolbar-title>
                                        <v-spacer></v-spacer>
                                    </v-toolbar>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-form>
            </v-app>
        </div>
    </v-dialog>
</template>
<style scoped>
.font-class-name {
    font-size: 10px !important;
    padding: 0 5px !important;
}

.font-class-name2 {
    font-size: 12px !important;
    padding: 0 5px !important;
}
</style>
<style scoped>
.v-btn:not(.v-btn--round).v-size--default {
    height: 26px;
    min-width: 64px;
    padding: 0 3px;
}
</style>
<script>
import axios from "../../axios-auth";
import moment from "moment";

export default {
    data: (vm) => ({
        lazy: false,
        valid: false,
        usuario: "",
        listadoP: [],
        listadoC: [],
        listadoR: [],
        listadoF: [],
        loadtable: false,
        loadtableC: false,
        loadtableF: false,
        loadtableR: false,
        headers: [
            { text: "N° de OT", value: "otrabajo", sortable: false },
            { text: "Item", value: "item", sortable: false },
            { text: "Detalle", value: "detalle", sortable: false },
            { text: "Fecha Pedido", value: "fechapedido", sortable: false },
            { text: "Fecha Necesidad", value: "fechanecesidad", sortable: false },
            { text: "Nota P.", value: "npedido", sortable: false },
            { text: "Fecha N.P.", value: "fechanpedido", sortable: false },
            { text: "Proveedor", value: "proveedor", sortable: false },
            { text: "Comentario", value: "comentario", sortable: false },
            { text: "Fecha Venc.", value: "fechavencimiento", sortable: false },
            { text: "Cantidad", value: "cantidad", sortable: false },
            { text: "Recibido", value: "recibido", sortable: false },
            { text: "Faltante", value: "faltante", sortable: false },
            { text: "Observ", value: "observ", sortable: false },
        ],
        headersC: [
            { text: "N° de OT", value: "otrabajo", sortable: false },
            { text: "Item", value: "item", sortable: false },
            { text: "Detalle", value: "detalle", sortable: false },
            { text: "Cantidad", value: "cantidadcomprar", sortable: false },
            { text: "Fecha Solicitud", value: "fechapedido", sortable: false },
            { text: "Fecha Necesidad", value: "fechanecesidad", sortable: false },

        ],
        headersF: [
            { text: "N° de OT", value: "otrabajo", sortable: false },
            { text: "Item", value: "item", sortable: false },
            { text: "Detalle", value: "detalle", sortable: false },
            { text: "Cantidad Solicitada", value: "cantidad", sortable: false },
            { text: "Cantidad Reservada", value: "reservada", sortable: false },
            { text: "Cantidad Entregada", value: "entregada", sortable: false },
            { text: "Faltante", value: "faltante", sortable: false },
        ],
        headersR: [
            { text: "N° de OT", value: "otrabajo", sortable: false },
            { text: "Item", value: "item", sortable: false },
            { text: "Detalle", value: "detalle", sortable: false },
            { text: "Cantidad Solicitada", value: "cantidad", sortable: false },
            { text: "Cantidad Reservada", value: "reservada", sortable: false },
            { text: "Cantidad Entregada", value: "entregada", sortable: false },
            { text: "Saldo Reserva", value: "saldo", sortable: false },
        ],

    }),
    props: ["visible", "numotdesde", "numothasta"],
    computed: {
        show: {
            get() {
                if (this.visible == true) {
                    this.cargarListados();
                }
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.vaciarModels();
                    this.$emit("close");
                }
            },
        },
    },

    methods: {

        colorcelda(item) {

            if (item == null || moment(item, "DD/MM/YYYY").isBefore(moment())) {
                return "red"
            }
            if (moment(item, "DD/MM/YYYY").isBefore(moment().add(30, 'days'), 'day') && moment(item, "DD/MM/YYYY").isAfter(moment())) {
                return "orange"
            }
            if (moment(item, "DD/MM/YYYY").isBefore(moment().add(60, 'days'), 'day') && moment(item, "DD/MM/YYYY").isAfter(moment().add(30, 'days'), 'day')) {
                return "orange lighten-2"
            }
            if (moment(item, "DD/MM/YYYY").isBefore(moment().add(90, 'days'), 'day') && moment(item, "DD/MM/YYYY").isAfter(moment().add(60, 'days'), 'day')) {
                return "yellow"
            }
            if (moment(item, "DD/MM/YYYY").isAfter(moment().add(90, 'days'), 'day')) {
                return "green"
            }

        },

        cargarListados() {
            this.vaciarModels();
            this.loadtable = true;
            this.loadtableC = true;
            this.loadtableF = true;
            this.loadtableR = true;
            const numotdesde = this.numotdesde;
            const numothasta = this.numothasta;
            let self = this;

            axios
                .get("/Lanzamiento/ListadoPendientellegada?", {
                    params: {
                        numotdesde: numotdesde,
                        numothasta: numothasta,
                    },
                })
                .then((response) => {
                    self.listadoP = response.data;
                    console.log(response.data)
                    self.loadtable = false;
                })
                .catch((error) => {
                    self.listadoP = [];
                    console.log(error);
                });

            axios
                .get("/Lanzamiento/ListadoPendientecompra?", {
                    params: {
                        numotdesde: numotdesde,
                        numothasta: numothasta,
                    },
                })
                .then((response) => {
                    response.data.forEach(element => {
                        if (element.cantidadcomprar > 0) {
                            self.listadoC.push(element);
                        }
                    });
                    //self.listadoC = response.data;
                    console.log(response.data)
                    self.loadtableC = false;
                })
                .catch((error) => {
                    self.listadoC = [];
                    console.log(error);
                });

            axios
                .get("/Lanzamiento/ListadoPendientefabric?", {
                    params: {
                        numotdesde: numotdesde,
                        numothasta: numothasta,
                    },
                })
                .then((response) => {
                    response.data.forEach(element => {
                        if (element.faltante > 0) {
                            self.listadoF.push(element);
                        }
                    });
                    //self.listadoC = response.data;
                    console.log(response.data)
                    self.loadtableF = false;
                })
                .catch((error) => {
                    self.listadoF = [];
                    console.log(error);
                });

            axios
                .get("/Lanzamiento/ListadoPendientereserva?", {
                    params: {
                        numotdesde: numotdesde,
                        numothasta: numothasta,
                    },
                })
                .then((response) => {
                    self.listadoR = response.data;
                    console.log(response.data)
                    self.loadtableR = false;
                })
                .catch((error) => {
                    self.listadoR = [];
                    console.log(error);
                });

        },

        vaciarModels() {
            this.listadoP = [];
            this.listadoR = [];
            this.listadoF = [];
            this.listadoC = [];

        },
    },
};
</script>
